<ng-container *transloco="let t; prefix: 'admin'">
  <div
    appScrollTo
    *ngIf="dataSource.data"
    class="container mat-elevation-z2 widget-background"
  >
    <ng-container *ngIf="selectedBooking == null">
      <div class="filters">
        <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
          <mat-label>{{ t("bookings.search") }}</mat-label>
          <input matInput (keyup)="applySearch($event)" [placeholder]="t('bookings.search_placeholder')" [(ngModel)]="searchTermValue" #input>
          <button *ngIf="searchTermValue" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-icon *ngIf="!searchTermValue" matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-checkbox [(ngModel)]="hidePast" (change)="applyFilter()" [disabled]="searchTerm != ''">
          {{ t("bookings.hide_past") }}
        </mat-checkbox>

        <mat-form-field appearance="fill" subscriptSizing="dynamic">
          <mat-label>{{ t("bookings.table_status") }}</mat-label>
          <mat-select
            [(ngModel)]="selectedStatuses"
            (selectionChange)="applyFilter()"
            multiple
            panelWidth="auto"
            [disabled]="searchTerm != ''"
          >
            <mat-option *ngFor="let status of bookingStatuses" [value]="status">
              {{ t("booking.status_" + status.toLowerCase()) }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="isMobile" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t("bookings.sort") }}</mat-label>
          <mat-select [(ngModel)]="mobileSortValue" (selectionChange)="onMobileSortChange()">
            <mat-option value="date-desc">{{ t("bookings.table_date") }} ↓</mat-option>
            <mat-option value="date-asc">{{ t("bookings.table_date") }} ↑</mat-option>
            <mat-option value="name-asc">{{ t("bookings.table_name") }} ↑</mat-option>
            <mat-option value="name-desc">{{ t("bookings.table_name") }} ↓</mat-option>
            <mat-option value="status-asc">{{ t("bookings.table_status") }} ↑</mat-option>
          </mat-select>
        </mat-form-field>

        <button mat-raised-button [color]="showAddForm ? 'accent' : 'primary'" (click)="showAddForm = !showAddForm">
          {{ showAddForm ? t("bookings.cancel_add") : t("bookings.add_booking") }}
        </button>
      </div>

      <div *ngIf="showAddForm" class="add-booking-form mat-elevation-z2">
        <ng-container *transloco="let tb; prefix: 'booking'">
          <h3>{{ t("bookings.add_booking") }}</h3>
          <p class="admin-note">
            <i>* {{ t("bookings.admin_notification_note") }}</i>
          </p>
          <form [formGroup]="addForm" (ngSubmit)="onAddSubmit()">
            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>{{ t("bookings.table_date") }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker"
                  formControlName="dateTime"
                  required
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ tb("service") }}</mat-label>
                <mat-select formControlName="service" required>
                  <mat-option *ngFor="let service of services" [value]="service">
                    {{ service.info[locale].name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div formGroupName="customer" class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>{{ tb("form.name") }}</mat-label>
                <input matInput formControlName="name" required />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ tb("form.email") }}</mat-label>
                <input matInput formControlName="email" type="email" required />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ tb("form.phone") }}</mat-label>
                <input matInput formControlName="phone" required />
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>{{ tb("form.location") }}</mat-label>
                <input matInput formControlName="location" required />
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ tb("form.message") }}</mat-label>
                <textarea matInput formControlName="message" rows="3"></textarea>
              </mat-form-field>
            </div>

            <div class="actions">
              <button
                mat-raised-button
                color="primary"
                type="submit"
                [disabled]="addForm.invalid || addForm.disabled"
              >
                {{ t("bookings.save_booking") }}
              </button>
            </div>
          </form>
        </ng-container>
      </div>

      <table
        id="bookingsTable"
        mat-table
        [dataSource]="dataSource"
        matSort
        class="bookings"
      >
        <!-- Mobile Data Column -->
        <ng-container matColumnDef="mobileData">
          <th mat-header-cell *matHeaderCellDef>{{ t("bookings.table_bookings") }}</th>
          <td mat-cell *matCellDef="let b">
            <div class="mobile-booking-card">
              <div class="card-header">
                <span class="date">{{ b.dateTime || b.request.dateTime | date:'shortDate' }}</span>
                <span class="status" [attr.data-status]="b.status">
                   <ng-container [ngSwitch]="b.status">
                    <span *ngSwitchCase="'REQUESTED'">{{ t("booking.status_requested") }}</span>
                    <span *ngSwitchCase="'PROVIDER_ACCEPTED'">{{ t("booking.status_provider_accepted") }}</span>
                    <span *ngSwitchCase="'CONFIRMED'">{{ t("booking.status_confirmed") }}</span>
                    <span *ngSwitchCase="'CANCELED'">{{ t("booking.status_canceled") }}</span>
                  </ng-container>
                </span>
              </div>
              <div class="card-body">
                <div class="name">{{ b.request.customer.name }}</div>
                <div class="location">{{ b.location || b.request.location }}</div>
                <div class="email">
                  <a [href]="'mailto:' + b.request.customer.email">{{ b.request.customer.email }}</a>
                </div>
                <div class="phone">
                  <a [href]="'tel:' + b.request.customer.phone">{{ b.request.customer.phone }}</a>
                </div>
              </div>
              <div class="card-footer">
                 <a [routerLink]="['../', b.id]">
                   <mat-icon inline="true">link</mat-icon> {{ b.id }}
                 </a>
                 <span class="errors" *ngIf="b.errors?.length">{{ b.errors?.join(",") }}</span>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ t("bookings.table_name") }}
          </th>
          <td mat-cell *matCellDef="let b">
            {{ b.request.customer.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ t("bookings.table_email") }}
          </th>
          <td mat-cell *matCellDef="let b">
            {{ b.request.customer.email }}
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ t("bookings.table_date") }}
          </th>
          <td mat-cell *matCellDef="let b">
            {{ b.dateTime || b.request.dateTime | date }}
          </td>
        </ng-container>

        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ t("bookings.table_location") }}
          </th>
          <td mat-cell *matCellDef="let b">
            {{ b.location || b.request.location }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ t("bookings.table_status") }}
          </th>
          <td mat-cell *matCellDef="let b">
            <ng-container [ngSwitch]="b.status">
              <span *ngSwitchCase="'REQUESTED'">{{
                t("booking.status_requested")
              }}</span>
              <span *ngSwitchCase="'PROVIDER_ACCEPTED'">{{
                t("booking.status_provider_accepted")
              }}</span>
              <span *ngSwitchCase="'CONFIRMED'">{{
                t("booking.status_confirmed")
              }}</span>
              <span *ngSwitchCase="'CANCELED'">{{
                t("booking.status_canceled")
              }}</span>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ t("bookings.table_link") }}
          </th>
          <td mat-cell *matCellDef="let b">
            <a [routerLink]="['../', b.id]">{{ b.id }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="errors">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <b>!</b>
          </th>
          <td mat-cell *matCellDef="let b">
            {{ b.errors?.join(",") }}
          </td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: isMobile ? mobileBookingsTableColumns : bookingsTableColumns"></tr>
      </table>

      <div
        class="unhandled"
        *ngIf="unhandledRequests != null && unhandledRequests.length > 0"
      >
        {{ t("bookings.unhandled_requests") }}:
        {{ unhandledRequests.join(",") }}
      </div>
    </ng-container>

    <ng-container *ngIf="selectedBooking != null">
      <a [routerLink]="['../', 'all']">{{ t("back") }}</a>
      <app-booking-details [booking]="selectedBooking" ></app-booking-details>
    </ng-container>
  </div>
</ng-container>
